<template>
  <IframeCmp type="125" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 赔付看板
  name: 'CompensationBoard',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

